import React from 'react';
import { Flex, Radio, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { SortOption } from '@apps/accommodations/AccommodationsConsole.types';
import { useSortOptions } from '@apps/accommodations/hooks/useSortOptions';

interface SortOptionsFacetProps {
  selectedValue: SortOption;
  onChange: (value: SortOption) => void;
}

export const SortOptionsFacet: React.FC<SortOptionsFacetProps> = ({ selectedValue, onChange }) => {
  const { sortOptions, sortTrans } = useSortOptions();

  return (
    <Flex flexDirection="column" gap={4}>
      <TextV2 typographyVariant="hed4">{sortTrans.title()}</TextV2>
      <Flex flexDirection="column" gap={3}>
        {sortOptions.map(option => (
          <Flex key={option.value} alignItems="center">
            <Radio
              onChange={() => onChange(option.value)}
              id={`sort-${option.value.toLowerCase()}`}
              checked={selectedValue === option.value}
              value={option.value}
              activeColor="#4951EF"
              name="sortBy"
              label={option.label}
              style={{ fontSize: pxToRem(16) }}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
